import {
  FullStory as FullStoryLogger,
  init as initializeFullStory,
} from "@fullstory/browser";
import type { V2OperationOptions } from "@fullstory/snippet";
import { FullStoryClient } from "./client";

declare global {
  var FS:
    | {
        getCurrentSession: () => string;
      }
    | undefined;
}

const isWindow = (): boolean => typeof window !== "undefined";

const resolveFullstory: {
  current?: () => void;
} = {};

export type FullStoryParameters = { orgId: string };
export const FullStory = ({ orgId }: FullStoryParameters) => (
  <>
    <script>{"window['_fs_capture_on_startup'] = false;"}</script>
    <FullStoryClient orgId={orgId} />
  </>
);

FullStory.initialize = ({ orgId }: FullStoryParameters) => {
  if (isWindow()) {
    initializeFullStory({ orgId }, () => {
      resolveFullstory.current?.();
    });
  }
};

FullStory.ready = new Promise<void>((resolve) => {
  resolveFullstory.current = () => {
    resolve();
  };
});

FullStory.setProperties = async ({
  properties,
  ...options
}: V2OperationOptions["setProperties"]) => {
  await FullStory.ready;
  FullStoryLogger("setProperties", {
    ...options,
    properties,
  });
};

FullStory.getSessionId = async (): Promise<string> => {
  await FullStory.ready;
  return globalThis.FS?.getCurrentSession() ?? "";
};
